import { useState } from 'react';
import { Modal, ModalHeader, Button, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../context';
import SuccessConfirmationModal from '../../SuccessConfirmationModal';

const RemovePluginConfirmationModal = (props) => {
    const { pluginRemovalCandidate, isOpen, closeModal, refreshManifest } =
        props;

    const [isRemoving, setIsRemoving] = useState(false);
    const [isSuccessComfirmationModalOpen, setIsSuccessComfirmationModalOpen] =
        useState(false);
    const [removePluginResponse, setRemovePluginResponse] = useState();

    const dispatch = useDispatch();

    const instanceId = useSelector(
        (state) => state.practice?.practice?.instanceId
    );

    const removePluginClick = () => {
        setIsRemoving(true);
        dispatch(
            actions.clientPlugins.removeClientPlugin(
                instanceId,
                pluginRemovalCandidate.uid,
                pluginRemovalCandidate.version
            )
        )
            .then((res) => {
                setRemovePluginResponse(res);
                closeModal();
                refreshManifest();
            })
            .then(() => {
                setIsSuccessComfirmationModalOpen(true);
                setIsRemoving(false);
            });
    };

    return (
        <>
            <SuccessConfirmationModal
                isOpen={isSuccessComfirmationModalOpen}
                closeBehavior={() => setIsSuccessComfirmationModalOpen(false)}
                successResponse={removePluginResponse}
            />
            <Modal isOpen={isOpen} centered className="text-light">
                <ModalHeader>{`Remove ${pluginRemovalCandidate.name} (v${pluginRemovalCandidate.version})?`}</ModalHeader>
                <ModalFooter>
                    <Button
                        color="light"
                        onClick={() => closeModal()}
                        disabled={isRemoving}>
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        onClick={() => removePluginClick()}
                        disabled={isRemoving}>
                        {isRemoving ? 'Removing...' : 'Remove'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default RemovePluginConfirmationModal;
